import {
  useOptionalWorkspaceTabsActions,
  useOptionalWorkspaceTabsState,
} from 'features/workspaceTabs/contexts/WorkspaceTabsContext'
import { publishWorkspaceTabTitle } from 'features/workspaceTabs/utils/publishWorkspaceTabTitle'
import { useEffect } from 'react'

import { useBoundWorkspaceTabId } from './useBoundWorkspaceTabId'

type UseWorkspaceTabTitleOptions = {
  followActiveTab?: boolean
}

/**
 * Page-owned workspace tab title. Call from any routed page to update the
 * tab this page mounted on as the user drills down (search query, entity
 * name, …). Pass `null` to clear a sticky customLabel (e.g. while document
 * metadata loads). When omitted / undefined, the tab keeps its current label.
 * No-ops when workspace tabs are not mounted (legacy layout).
 */
export function useWorkspaceTabTitle(
  title: string | null | undefined,
  options?: UseWorkspaceTabTitleOptions
): void {
  const setActiveTabTitle = useOptionalWorkspaceTabsActions()?.setActiveTabTitle
  const activeTabId = useOptionalWorkspaceTabsState()?.activeTabId
  const boundTabId = useBoundWorkspaceTabId()
  const followActiveTab = options?.followActiveTab === true

  useEffect(() => {
    if (
      !followActiveTab &&
      boundTabId !== undefined &&
      activeTabId !== boundTabId
    ) {
      return
    }
    publishWorkspaceTabTitle(setActiveTabTitle, title)
  }, [activeTabId, boundTabId, followActiveTab, setActiveTabTitle, title])
}
